import React, { useContext } from 'react'
import { useState } from 'react';
import { useEffect } from 'react'
import { Camelcase, CamelCaseWithSpaces, getTypeWatchDelay, LogInUserID, onKeyDownRestrict, onPasteRestriction, transformNameOfCol, typewatch } from '../../JS/Common';
import Pagination from 'react-js-pagination';
import { ApiGetCall, ApiGetHeaders, ApiPostCall } from '../../JS/Connector';
import { CheckValidation } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import { MDBSwitch } from 'mdb-react-ui-kit';
import { faRightLeft, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomizationPopup from '../../Components/CustomizationPopup';
import { useNavigate } from 'react-router-dom';
import PageHead from '../../Components/PageHead';
import Popup from '../../Components/Popup';
import Deletepopup from '../../Components/Deletepopup';
import useConfig from '../../Hooks/useConfig';
import { useStickyAction } from '../../Hooks';
import CustomFontAwesomeIcon from '../../Components/CustomFontAwesomeIcon';

export function MasterInventory() {
    const { show_import_export_nav_btn, origin_flag, adminCallNode } = useConfig();
    const [loading, setLoading] = useState(false);
    const [InventoryData, setInventoryData] = useState([]);
    const [InventoryPopup, setInventoryPopup] = useState(false);
    const [Alerts, setNewAlerts] = useState("");
    const initialAllData = {
        Title: "",
        Price: "",
        PartId: "",
        Handle: "",
        SortbyFlag: 'asc',
        InternalID: '',
        InternalSKU: '',
        Brand: '',
        markAsSwapNotes: 2,
        applyToAllModels: 0,
        selectedModelIds: []
    }
    const [AllData, setAllData] = useState(initialAllData);
    const [Searchstring, setSearchstring] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [addUpdateFlag, setAddUpdateFlag] = useState('')
    const showPagination = InventoryData?.length > 0;
    var TenantFlag = origin_flag;
    const [CustomizationModal, setCustomizationModal] = useState(false)
    const [deletePopup, setdeletePopup] = useState(false)
    const [deleteId, setdeleteId] = useState('')
    const [columnNames, setColumnNames] = useState([]);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    const initialModelState = {
        data: [],
        loader: false,
        showSuggestionBox: false,
        searchString: "",
    }
    const [allModelsData, setAllModelsData] = useState(initialModelState);
    const navigate = useNavigate();
    useEffect(() => {
        ApiGetHeaders(36, setColumnNames)
    }, []);

    useEffect(() => {
        GetAllMasterInventory(Searchstring ? Searchstring : null, AllData.SortbyFlag || null, false);
    }, [currentPage, LimitForPagination]);

    async function GetAllModels(searchString) {
        if (searchString?.trim() == "" || searchString == undefined) {
            setAllModelsData(prev => ({ ...prev, loader: false }));
            searchString = null;
        } else {
            searchString = searchString?.trim() || null;
        }
        setAllModelsData(prev => ({ ...prev, loader: true, showSuggestionBox: searchString && true }));
        typewatch(async function () {
            await ApiGetCall(`/device-models?uuid=${"null"}&search=${searchString}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs.length > 0) {
                        setAllModelsData(prev => ({ ...prev, data: responseRs, loader: false }));
                    } else {
                        setAllModelsData(prev => ({ ...prev, data: [], loader: false }));
                    }
                }
            });
        }, 1000);
    }

    async function GetAllMasterInventory(searchkey, sFlag, toogleSort) {
        if (!searchkey) searchkey = null;
        if (toogleSort) sFlag = sFlag == "asc" ? "desc" : "asc";
        setAllData({ ...AllData, SortbyFlag: sFlag })
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/inventory/master/all?sortBy=${encodeURIComponent(searchkey)}&sortByOrder=${encodeURIComponent(sFlag)}&page=${encodeURIComponent(currentPage)}&limit=${encodeURIComponent(LimitForPagination)}&userId=${encodeURIComponent(LogInUserID)}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    setpageRangeCount(responseRs.master_sku.total);
                    setInventoryData(responseRs.master_sku?.data?.length ? responseRs.master_sku.data : [])
                }
            });
        }, getTypeWatchDelay(searchkey, 500));
    }
    async function EditMasterInventoryData(id) {
        setLoading(true)
        setAllData(initialAllData)
        setInventoryPopup(true);
        await ApiGetCall(`/inventory/master/by-id?uuid=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setAllData({
                    ...AllData, Title: responseRs.title, Price: responseRs.variant_price, PartId: responseRs.id,
                    Handle: responseRs.handle, InternalID: responseRs.netsuite_internal_code,
                    InternalSKU: responseRs.netsuite_internal_sku, Brand: responseRs.brand_name,
                    markAsSwapNotes: responseRs?.swap_note_flag, applyToAllModels: responseRs?.apply_to_all_models,
                    selectedModelIds: responseRs?.device_models || []
                })
            }
        });
    }
    async function AddUpdateMasterPart(flag) {
        var isFormValid = CheckValidation({ formID: "InventoryPopup" });
        if (!isFormValid) return;
        setLoading(true);
        var raw = JSON.stringify({
            uuid: AllData.PartId || null,
            title: AllData.Title,
            price: AllData.Price,
            flag: flag,
            handle: AllData.Handle,
            internalSKU: AllData.InternalSKU,
            internalUid: AllData.InternalID,
            brandName: AllData.Brand,
            markAsSwapNotes: AllData.markAsSwapNotes,
            applyToAllModels: AllData.applyToAllModels,
            deviceModelIds: AllData.selectedModelIds.map(d => d.id) || []
        });
        await ApiPostCall("/inventory/master/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setInventoryPopup(false);
                if (responseRs.response == "success") {
                    var msg = flag == 1 ? 'Part Added Successfully' : 'Part Updated Successfully';
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        GetAllMasterInventory(null, "asc", false);
                    }, 2000);
                } else {
                    const res = JSON.parse(result)
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={res?.msg || result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function ChangeMasterPartStatus(partid, flag, e) {
        setLoading(true);
        const { name, checked } = e.target;
        let tempuser = InventoryData.map(user =>
            user.id == name ? { ...user, isChecked: checked } : user
        );
        setInventoryData(tempuser);
        var raw = JSON.stringify({
            uuid: partid,
            flag: 2
        });
        await ApiPostCall("/inventory/master/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setInventoryPopup(false);
                if (responseRs.response == "success") {
                    var msg = flag == 1 ? 'Part Deactivated Successfully' : 'Part Activated Successfully';
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        GetAllMasterInventory(null, 'asc', false);
                    }, 2000);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    async function DeletePart() {
        var raw = JSON.stringify({
            uuid: deleteId,
            flag: 3
        });
        setLoading(true);
        await ApiPostCall("/inventory/master/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                setInventoryPopup(false);
                if (responseRs.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Part Deleted Successfully."} />);
                    setdeletePopup(false);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        GetAllMasterInventory(null, 'asc', false);
                    }, 2000);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "Title": item.title || '-',
            "Variant_Price": `$${item.variant_price || 0}`,
            "Quantity": item.quantity || '-',
            "NetSuite_SKU": item.netsuite_internal_sku || '-',
            "NetSuite_ID": item.netsuite_internal_code || '-',
            "Handle": <div className='address'>{item.handle || '-'}</div>,
            "Brand": item.brand_name || "-",
        };
        return contentMap[columnName] || null;
    }
    function handleSearchChange(e) {
        setCurrentPage(1);
        GetAllMasterInventory(e.target.value, AllData.SortbyFlag, false);
        setSearchstring(e.target.value)
    }

    const AddSelectedModelIds = (isCheckboxState, deviceModel) => {
        setAllData(prev => {
            const exists = prev.selectedModelIds.some(p => p.id === deviceModel.id);
            if (isCheckboxState) {
                if (exists) return prev;
                return { ...prev, selectedModelIds: [...prev.selectedModelIds, { id: deviceModel.id, name: deviceModel.name }] };
            } else {
                return { ...prev, selectedModelIds: prev.selectedModelIds.filter(p => p.id !== deviceModel.id) };
            }
        });
    }

    async function ChangeApplyToAllModelsStatus(partid, flag, e) {
        setLoading(true);
        const { name, checked } = e.target;
        let tempuser = InventoryData.map(user =>
            user.id == name ? { ...user, apply_to_all_models: checked ? 1 : 0 } : user
        );
        setInventoryData(tempuser);
        var raw = JSON.stringify({
            uuid: partid,
            flag: 4
        });
        await ApiPostCall("/inventory/master/save", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
                setLoading(false);
                //  GetAllMasterInventory(null, 'asc', false);
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                setInventoryPopup(false);
                if (responseRs.response == "success") {
                    var msg = flag == 1 ? 'Applied to All Models' : 'Removed from All Models';
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        // GetAllMasterInventory(null, 'asc', false);
                    }, 2000);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        //GetAllMasterInventory(null, 'asc', false);
                    }, 2000);
                }
            }
        });
    }

    const modalBody = (
        <div id="InventoryPopup" className="parent row">
            <div className='col-md-12'>
                <div className='FormLabel'>Title<label className='redText'>*</label></div>
                <input type="text" className="form-control" name='title' required value={AllData.Title}
                    onChange={(e) => setAllData({ ...AllData, Title: e.target.value?.trimStart() })}
                    onBlur={(e) => setAllData({ ...AllData, Title: e.target.value?.trim() })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-md-6 pt-3'>
                <div className='FormLabel'>Price<label className='redText'>*</label></div>
                <div className="input-group">
                    <span className="input-group-text">$</span>
                    <input type="number" autoComplete="off" className="form-control" name="variantPrice"
                        min={0} value={AllData.Price} required onChange={(e) => setAllData({ ...AllData, Price: e.target.value })}
                        onKeyDown={(e) => {
                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                e.preventDefault();
                            }
                        }}
                        onPaste={(e) => e.preventDefault()}
                    />
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
            </div>
            <div className='col-md-6 pt-3'>
                <div className='FormLabel'>Brand Name</div>
                <input type="text" className="form-control" name='brandName' value={AllData.Brand}
                    onChange={(e) => setAllData({ ...AllData, Brand: e.target.value?.trimStart() })}
                    onBlur={(e) => setAllData({ ...AllData, Brand: e.target.value?.trim() })} />
            </div>
            <div className='col-md-6 pt-3'>
                <div className='FormLabel'>NetSuite ID<label className='redText'>*</label></div>
                <input
                    type='number'
                    className="form-control"
                    name='internalid'
                    required
                    value={AllData.InternalID}
                    onChange={(e) => setAllData({ ...AllData, InternalID: e.target.value })}
                    onKeyDown={(e) => {
                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                            e.preventDefault();
                        }
                    }}
                    onPaste={(e) => e.preventDefault()}
                />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='col-md-6 pt-3'>
                <div className='FormLabel'>NetSuite SKU<label className='redText'>*</label></div>
                <input type="text" className="form-control" name='internalsku' required value={AllData.InternalSKU}
                    onChange={(e) => setAllData({ ...AllData, InternalSKU: e.target.value?.trimStart() })}
                    onBlur={(e) => setAllData({ ...AllData, InternalSKU: e.target.value?.trim() })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='pt-3'>
                <div className='FormLabel'>Handle<label className='redText'>*</label></div>
                <input type="text" className="form-control col-12" name='handle' required value={AllData.Handle}
                    onChange={(e) => setAllData({ ...AllData, Handle: e.target.value?.trim() })}
                    onBlur={(e) => setAllData({ ...AllData, Handle: e.target.value?.trim() })} />
                <span className="form-text invalid-feedback">
                    *required
                </span>
            </div>
            <div className='pt-3'>
                <div className='d-flex gap-2'>
                    <input type="checkbox" className="form-check-input mt-1 cursor-pointer"
                        name='markAsSwapNotes' checked={AllData.markAsSwapNotes == 1} id='master-part-notes'
                        onChange={(e) => setAllData({ ...AllData, markAsSwapNotes: e.target.checked ? 1 : 2 })} />
                    <label className='FormLabel' htmlFor='master-part-notes'> Use Part Notes in Place of Part Name for Billing Download </label>
                </div>
            </div>
            <div className='pt-3'>
                <div className='d-flex gap-2'>
                    <input type="checkbox" className="form-check-input mt-1 cursor-pointer"
                        name='applyToAllModels' checked={AllData.applyToAllModels == 1} id='apply-to-all-models'
                        onChange={(e) => {
                            setAllModelsData(initialModelState);
                            setAllData({ ...AllData, applyToAllModels: e.target.checked ? 1 : 0, selectedModelIds: [] })
                        }} />
                    <label className='FormLabel' htmlFor='apply-to-all-models'> Apply to All Models </label>
                </div>
            </div>

            {AllData.applyToAllModels != 1 && (
                <>
                    <div className="col-md-12 pt-3" tabIndex={-1}
                        onBlur={(e) => {
                            if (!e.currentTarget.contains(e.relatedTarget)) {
                                setAllModelsData(initialModelState);
                            }
                        }}>
                        <input id="model-search-box" className="form-control" autoComplete="off" type="text"
                            value={allModelsData.searchString} placeholder="Search Device models to add to this part"
                            onChange={(e) => {
                                setAllModelsData(prev => ({ ...prev, searchString: e.target.value }));
                                GetAllModels(e.target.value)
                            }}
                            onPaste={onPasteRestriction}
                            onKeyDown={onKeyDownRestrict}
                        />
                        {allModelsData.showSuggestionBox && (
                            <div className="col-12 position-relative">
                                <div className="SuggestionBoxDiv" style={{ zIndex: 5, maxHeight: '250px' }}>
                                    {allModelsData?.loader ?
                                        <div className='row'>
                                            <div className="col-12 text-center pt-2">
                                                <img src="/images/loder.svg" style={{ width: "30px" }} />
                                            </div>
                                        </div>
                                        : allModelsData?.data?.length != 0 ?
                                            allModelsData?.data?.map((deviceModel) => (
                                                <div tabIndex={0} className="row brdr-Btm font-14 schoolid p-Suggestion"
                                                    onClick={(e) => {
                                                        if (e.target.type === 'checkbox') return;
                                                        const exists = AllData.selectedModelIds.some(p => p.id === deviceModel.id);
                                                        AddSelectedModelIds(!exists, deviceModel);
                                                    }}>
                                                    <div className="col-12 text-start d-flex align-items-center">
                                                        <input type="checkbox" className='form-check-input cursor-pointer'
                                                            checked={AllData.selectedModelIds.some(p => p.id === deviceModel.id)}
                                                            onChange={(e) => {
                                                                e.stopPropagation();
                                                                AddSelectedModelIds(e.target.checked, deviceModel)
                                                            }} />
                                                        <label className='ps-2 cursor-pointer'>{deviceModel.name}</label>
                                                    </div>
                                                </div>
                                            ))
                                            : <div className="col-12 text-center"> <label> No Record Found </label> </div>
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-md-12 mt-3" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                        <div className="d-flex flex-wrap gap-2">
                            {AllData.selectedModelIds?.length > 0 &&
                                AllData.selectedModelIds?.map((deviceModel) => (
                                    <div className="mb-2 w-auto pe-0" key={deviceModel.id}>
                                        <div className="BorderBtn me-0">
                                            <label className="me-2 cursor-pointer">
                                                {deviceModel.name}
                                            </label>
                                            <CustomFontAwesomeIcon title="Remove Device Model" icon={faXmark} size="lg"
                                                onClick={() => setAllData(prev => ({ ...prev, selectedModelIds: prev.selectedModelIds.filter(p => p.id !== deviceModel.id) }))}
                                            />
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </>
            )}
        </div>
    )
    return (
        <React.Fragment>
            <PageHead LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination}
                setCurrentPage={setCurrentPage} heading={"Master Inventory"} handleSearch={handleSearchChange}
                loading={loading} Alerts={Alerts} showsearch={true} />
            <div className="row mt-2 align-items-center">
                <div className='col-md-12 text-end'>
                    {show_import_export_nav_btn && (
                        <label title='Import & Export Inventory' className="BorderBtn p-2 me-2 text-center" onClick={() => { navigate('/import-export') }}>
                            <FontAwesomeIcon icon={faRightLeft} className="pe-2" />
                            Import & Export Inventory
                        </label>
                    )}
                    <label title='Add Inventory' className="p-2 BorderBtn text-center" onClick={(e) => { setAddUpdateFlag(1); setInventoryPopup(true); setAllData(initialAllData) }} >
                        Add Inventory
                        <img src="/images/AddInventory.svg" className="img-fluid ps-2" />
                    </label>
                </div>
            </div>
            <div className="GridBox mt-2 p-3">
                <div className="greyBox p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>
                                    {columnNames?.map((item) => {
                                        const columnName = item.replace(/_/g, ' ');
                                        const transformedName = transformNameOfCol(columnName);
                                        if (!transformedName) return null;
                                        return (
                                            item == "Title" ?
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)} `} onClick={() => GetAllMasterInventory(Searchstring, AllData.SortbyFlag, true)}>
                                                    {Camelcase(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName} `} className="img-fluid ps-2 sortbyClass" />
                                                </th>
                                                :
                                                <th key={item} scope="col" className='fw-600'>
                                                    {Camelcase(transformedName)}
                                                </th>
                                        );
                                    })}
                                    <th scope="col" className='fw-600'>Apply to All Models</th>
                                    <th scope="col" className='fw-600'>Status</th>
                                    <th scope="col" className={`fw-600 ${isOverflowing ? 'sticky-action' : ''}`}>
                                        <div className="d-flex justify-content-center">
                                            Action
                                            <div className="EditHeaderIconDiv">
                                                <img src="/images/EditHeaderIcon.svg" className="cursor-pointer img-fluid ps-2"
                                                    title='Customize Headers' style={{ height: '25px' }}
                                                    onClick={(e) => setCustomizationModal(true)}
                                                />
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {InventoryData.length != 0 ?
                                    InventoryData.map((item, i) => {
                                        return (
                                            <tr key={i} className="OddEvenClass tableBorderHide">
                                                {columnNames?.map(header => (
                                                    <td className="py-12" key={header}>
                                                        {renderContentForColumn(header, item)}
                                                    </td>
                                                ))}

                                                <td className='py-12'>
                                                    <MDBSwitch name={item.id} checked={item?.apply_to_all_models == 1} className="BgPink cursor-pointer" onChange={(e) => { ChangeApplyToAllModelsStatus(item.id, item?.apply_to_all_models == 1 ? "2" : "1", e) }} partid={item.id} />
                                                </td>
                                                <td className="py-12">
                                                    {item.status == 1 ?
                                                        <MDBSwitch name={item.id} checked={item?.isChecked || true} className="BgPink cursor-pointer" onChange={(e) => { ChangeMasterPartStatus(item.id, "1", e) }} partid={item.id} />
                                                        :
                                                        <MDBSwitch name={item.id} checked={item?.isChecked || false} className="BgPink cursor-pointer" onChange={(e) => { ChangeMasterPartStatus(item.id, "2", e) }} partid={item.id} />
                                                    }
                                                </td>
                                                <td scope="col" className={`py-12 ${isOverflowing ? 'sticky-action' : ''}`}>
                                                    <img src='/images/EditIconNew.svg' title='Edit Master Part' className='img-fluid pe-2 cursor-pointer'
                                                        onClick={(e) => { setAddUpdateFlag(0); EditMasterInventoryData(item.id) }} />
                                                    <img src="/images/DeleteIcon.svg" title="Delete Master Part" className="img-fluid cursor-pointer"
                                                        onClick={(e) => { setdeletePopup(true); setdeleteId(item.id) }} />

                                                </td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td colSpan={15} className="p-3 text-center">
                                            No Record Found
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {showPagination && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => setCurrentPage(e)}
                        color="primary"
                        lastPageText=""
                        firstPageText=""
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                )}
            </div>
            <Popup isshow={InventoryPopup} size={"md"} title={addUpdateFlag == 1 ? 'Add Master Part' : 'Edit Master Part'}
                closePopup={(e) => { setInventoryPopup(false); setAllData(initialAllData); setAllModelsData(initialModelState); }}
                modalBody={modalBody} handleSave={(e) => addUpdateFlag == 1 ? AddUpdateMasterPart(1) : AddUpdateMasterPart(0)}
                visibleSaveBtn={true} btnText={addUpdateFlag == 1 ? 'Add' : 'Update'} />

            {CustomizationModal && <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} gridname={'Master Inventory'} modalSize={'l'} GetCall={(e) => ApiGetHeaders(36, setColumnNames)} />}

            <Deletepopup text={`You won't be able to revert this!`} deletePopup={deletePopup}
                deletePart={DeletePart} DeleteShowClose={(e) => setdeletePopup(false)}></Deletepopup>

        </React.Fragment>
    )
}

